<template>
  <DataTable
    striped-rows
    lazy
    row-hover
    responsive-layout="scroll"
    filter-display="row"
    breakpoint="300"
    class="p-datatable-sm"
    :row-class="checkRejected"
  >
    <slot name="before" />

    <Column
      field="licencePeriod"
      :header="$t('entity.lineId.licencePeriod')"
      :sortable="true"
      :show-filter-menu="false"
      :show-clear-button="false"
      style="min-width:200px"
    >
      <template #body="{data}">
        <span v-if="data.licencePeriod">
          {{
            $t(`entity.lineId.licencePeriods.${data.licencePeriod}`)
          }}
        </span>
      </template>
    </Column>

    <Column
      field="mainVenue"
      :header="$t('entity.lineId.mainVenue')"
      :sortable="true"
      :show-filter-menu="false"
      :show-clear-button="false"
      style="min-width:200px"
    >
      <template #body="{data}">
        <span v-if="data.mainVenue">
          {{ $i18n.locale === 'fr' ? data.mainVenue.frenchWording : data.mainVenue.englishWording }}
        </span>
      </template>
    </Column>

    <Column
      v-if="showSpectrumService"
      field="spectrumService"
      :header="$t('entity.lineId.spectrumService')"
      :sortable="true"
      :show-filter-menu="false"
    >
      <template #body="{data}">
        <span v-if="data.spectrumService">
          {{ data.spectrumService }}
        </span>
      </template>
    </Column>

    <Column
      v-if="showStakeholderId"
      field="stakeholderId"
      :header="$t('entity.lineId.stakeholderId')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:200px; min-width:200px"
      sort-field="stakeholder.stakeholderId"
    >
      <template #body="{data}">
        {{ data.stakeholderId }}
      </template>
    </Column>

    <Column
      field="duplexHigh"
      :header="$t('entity.lineId.duplexHigh')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:100px"
    >
      <template #body="{data}">
        <span v-if="data.duplexHigh">
          {{ data.duplexHigh }}
        </span>
      </template>
    </Column>

    <Column
      field="duplexLow"
      :header="$t('entity.lineId.duplexLow')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:100px"
    >
      <template #body="{data}">
        <span v-if="data.duplexLow">
          {{ data.duplexLow }}
        </span>
      </template>
    </Column>

    <Column
      v-if="showChannelBandwidth"
      field="channelBandwidth"
      :header="$t('entity.lineId.channelBandwidth')"
      :sortable="true"
      :show-filter-menu="false"
    >
      <template #body="{data}">
        <span v-if="data.channelBandwidth">
          {{ data.channelBandwidth }}
        </span>
      </template>
    </Column>

    <Column
      v-if="showDates"
      field="startDate"
      :header="$t('entity.lineId.startDate')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:100px"
    >
      <template #body="{data}">
        <span>
          {{ data.startDate }}
        </span>
      </template>
    </Column>

    <Column
      v-if="showDates"
      field="endDate"
      :header="$t('entity.lineId.endDate')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:100px"
    >
      <template #body="{data}">
        <span>
          {{ data.endDate }}
        </span>
      </template>
    </Column>

    <Column
      v-if="showAssociated"
      field="associated"
      :header="$t('entity.lineId.associated')"
      :sortable="false"
      :show-filter-menu="false"
    >
      <template #body="{data}">
        <span>
          <em
            v-if="data.associated"
            class="pi pi-check"
          />
          <em
            v-else
            class="pi pi-times"
          />
        </span>
      </template>
    </Column>
    <slot name="after" />
  </DataTable>
</template>

<script>

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
  name: 'LineIdTable',
  components: {Column, DataTable},
  props: {
    showStakeholderId: {
      type: Boolean,
      default: true,
    },
    showDates: {
      type: Boolean,
      default: false,
    },
    showSpectrumService: {
      type: Boolean,
      default: false,
    },
    showChannelBandwidth: {
      type: Boolean,
      default: false,
    },
    showAssociated: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      licencePeriods: [],
      uniqueSiteCode: this.$store.getters["setting/getUniqueSiteCode"],
      uniqueSiteMode: this.uniqueSiteCode && this.uniqueSiteCode !== ''
    }
  },
  created() {
    this.licencePeriods = this.$store.getters['setting/getLineIdLicencePeriods'];
  },
  methods: {
    checkRejected(data){
      return data.status == 'REFUSED' ? 'table-rows-refused' : ''
    }
  }

}

</script>

